import { createRoot } from 'react-dom/client'
import './index.css'
import '../src/output.css'
import App from './App'
import { SnackbarProvider } from 'notistack'
import { HelmetProvider } from 'react-helmet-async';
createRoot(document.getElementById('root')).render(
  <SnackbarProvider
    maxSnack={3}
    autoHideDuration={3000}
  >
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </SnackbarProvider>,
)
